var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "c-statusChart" }, [
    _c("h2", { staticClass: "c-statusChart_title" }, [
      _vm._v("COTAÇÕES POR STATUS"),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-statusChart_body" }, [
      _c(
        "div",
        { staticClass: "c-statusChart_chartWrap" },
        [
          _vm.isEmptyChart
            ? _c("chartEmptyState", {
                attrs: {
                  color: "#F6F6F6",
                  diameter: 160 / 2,
                  thickness: 160 / 2,
                },
              })
            : _c("Doughnut", {
                attrs: {
                  id: "status",
                  "chart-options": _vm.chartOptions,
                  "chart-data": _vm.chartData,
                  width: 160,
                  height: 160,
                },
              }),
          _vm._v(" "),
          _c("div", { staticClass: "c-statusChart_info" }, [
            _c("h3", { staticClass: "c-statusChart_infoTitle" }, [
              _vm._v(_vm._s(_vm.sumDate)),
            ]),
            _vm._v(" "),
            _c("h4", { staticClass: "c-statusChart_infoSubTitle" }, [
              _vm._v("COTAÇÕES"),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "c-statusChart_labelWrap" }, [
        _c("div", { staticClass: "c-statusChart_label" }, [
          _c(
            "svg",
            {
              class: "c-statusChart_labelIcon--yellow",
              attrs: {
                width: "14",
                height: "9",
                viewBox: "0 0 14 9",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "svg-inline": "",
                role: "presentation",
                focusable: "false",
                tabindex: "-1",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M14 .147a.043.043 0 00-.021-.04.043.043 0 00-.045 0L5.203 5.182a.118.118 0 01-.122 0L.066 2.326a.043.043 0 00-.066.04v3.588a.043.043 0 00.023.039l5.058 2.89a.118.118 0 00.122 0l8.729-5.049a.126.126 0 00.062-.105L14 .147z",
                  fill: "currentColor",
                },
              }),
            ]
          ),
          _vm._v("\n        Em andamento\n      "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "c-statusChart_label" }, [
          _c(
            "svg",
            {
              class: "c-statusChart_labelIcon--purple",
              attrs: {
                width: "14",
                height: "9",
                viewBox: "0 0 14 9",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "svg-inline": "",
                role: "presentation",
                focusable: "false",
                tabindex: "-1",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M14 .147a.043.043 0 00-.021-.04.043.043 0 00-.045 0L5.203 5.182a.118.118 0 01-.122 0L.066 2.326a.043.043 0 00-.066.04v3.588a.043.043 0 00.023.039l5.058 2.89a.118.118 0 00.122 0l8.729-5.049a.126.126 0 00.062-.105L14 .147z",
                  fill: "currentColor",
                },
              }),
            ]
          ),
          _vm._v("\n\n        Em negociação\n      "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "c-statusChart_label" }, [
          _c(
            "svg",
            {
              class: "c-statusChart_labelIcon--blue",
              attrs: {
                width: "14",
                height: "9",
                viewBox: "0 0 14 9",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "svg-inline": "",
                role: "presentation",
                focusable: "false",
                tabindex: "-1",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M14 .147a.043.043 0 00-.021-.04.043.043 0 00-.045 0L5.203 5.182a.118.118 0 01-.122 0L.066 2.326a.043.043 0 00-.066.04v3.588a.043.043 0 00.023.039l5.058 2.89a.118.118 0 00.122 0l8.729-5.049a.126.126 0 00.062-.105L14 .147z",
                  fill: "currentColor",
                },
              }),
            ]
          ),
          _vm._v("\n        Concluída\n      "),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }